import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Platform, Tab, Tabs } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

//import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';

import { TranslateService } from "@ngx-translate/core";
import { AppSettings } from './app.settings';
//import { AnalyticsService } from "./services/analytics.service";
import { DataProvider } from "../providers/data";
//import { UserSettingsComponent } from "./user-settings/user-settings.component";
//import { TestProductsComponent } from './products/test/test-products.component';
//import { TestProductDetailComponent } from './products/test/test-product-detail.component';

//import { Subscription } from 'rxjs/Rx';
//import { TimerObservable } from "rxjs/observable/TimerObservable";
//import { DatePipe } from '@angular/common';

import { BootsMapPage } from '../pages/boots-map/boots-map';
import { WelcomePage } from '../pages/welcome/welcome';
import { FavouritesPage } from '../pages/favourites/favourites';
import { AskPage } from '../pages/ask/ask';
import { InfoPage } from '../pages/info/info';
//import { DataProvider } from '../providers/data';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('mainTabs') tabRef: Tabs;
  //rootPage: any = WelcomePage;
  passTestPage: any = WelcomePage;
  bootsMapPage: any = BootsMapPage;
  favPage: any = FavouritesPage;
  askPage: any = AskPage;
  infoPage: any = InfoPage;

  private activeSlaveComponent: Component;
  public get favProductsCount() {
    return this.dataService.FAV_PRODUCTS_COUNT;
  }

  //private alwaysActiveComponents = [WelcomeComponent, UserSettingsComponent, TestProductsComponent, TestProductDetailComponent];

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen,
    private translate: TranslateService,
    private ref: ChangeDetectorRef,
    /*public analyticsService: AnalyticsService,*/ private dataService: DataProvider) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });

    dataService.getConfig().subscribe(data => {
      //dataService.setConfig(data);
      AppSettings.CONFIG = data;

      this.dataService.FAV_PRODUCTS_COUNT = this.dataService.getFavProducts().length;
    });
  }

  ionViewDidEnter() {
    //this.tabRef.select(0);
    // this.initLanguage();
    // this.activatedRoute.queryParams.subscribe((params: Params) => {
    //   let lang = params['lang'];
    //   if (lang) {
    //     this.initLanguage(lang);
    //   }
    // });
  }

  // public onActivate(slaveComponent: any) {
  //   this.activeSlaveComponent = slaveComponent;
  // }

  public selectedTabIndex: number = 0;
  public selectTab(tab: Tab, page: any) {
    tab.root = null;
    console.log(tab);
    tab.root = page;
    //this.tabRef.goToRoot({}).then(s => this.ref.detectChanges(), k => this.ref.detectChanges());
   // this.ref.detectChanges();
    //tab.goToRoot({}).then(s => this.ref.detectChanges(), k => this.ref.detectChanges());
    //this.ref.detectChanges();
    //if (this.selectedTabIndex !== tabIndex)
    //this.tabRef.goToRoot
   // this.selectedTabIndex = tabIndex;
  }

  public ggg() {
    console.log('fffftab');
  }

  // public onTabSelect(e: any, tab: any) {
  //   console.log(tab);
  //  // this.tabRef.select(tab);
  // }

  // public initLanguage(urlLang: string = null) {
  //   let currentLanguage = urlLang || /*localStorage.getItem("es-language") ||*/ AppSettings.DEFAULT_LANGUAGE;
  //   localStorage.setItem("es-language", currentLanguage);
  //   this.translate.setDefaultLang(currentLanguage);
  //   this.translate.use(currentLanguage);
  // }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts